/*
 *
 * NotificationContainer actions
 *
 */

import {
  DEFAULT_ACTION,
  UPDATE_BADGE,
  MARK_ALL,
  MARK_AS_READ,
  FETCH_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_FAILED,
  FETCH_NOTIFICATIONS_SUCCESS,
  GO_TO_NOTIFICATION,
  GO_TO_NOTIFICATION_SUCCESS,
  SET_ALL_READ,
  SET_ALL_READ_SUCCESS,
  SET_COUNT,
} from "./constants"

export function defaultAction() {
  return { type: DEFAULT_ACTION }
}

export const updateBadge = (payload) => ({
  type: UPDATE_BADGE,
  payload,
})

export const markAllasRead = (_) => ({ type: MARK_ALL })

export const markasRead = (payload) => ({
  type: MARK_AS_READ,
  payload,
})

export const fetchNotifications = (payload) => ({
  type: FETCH_NOTIFICATIONS,
  payload,
})

export const fetchNotificationsFailed = (_) => ({
  type: FETCH_NOTIFICATIONS_FAILED,
})

export const fetchNotificationsSuccess = (payload) => ({
  type: FETCH_NOTIFICATIONS_SUCCESS,
  payload,
})

export const goToNotification = (payload) => ({
  type: GO_TO_NOTIFICATION,
  payload,
})

export const GoToNotificationSuccess = (payload) => ({
  type: GO_TO_NOTIFICATION_SUCCESS,
  payload,
})

export const setAllRead = (_) => ({ type: SET_ALL_READ })

export const setAllReadSuccess = (_) => ({ type: SET_ALL_READ_SUCCESS })

export const setCount = (payload) => ({
  type: SET_COUNT,
  payload,
})
